import React from 'react';
import PropTypes from 'prop-types';
import Lightbox from '../lightbox/lightbox';
import { FSFNotAvailableLightBoxHeader } from './fsf_not_available_light_box_header';
import { FSFNotAvailableLightBoxContent } from './fsf_not_available_light_box_content';

function FSFNotAvailableLightBox(props) {
    return (
        <Lightbox
            opened={props.visible}
            onClose={props.onClose}
            additionalClassNames={['fsf-na-light-box__lightbox']}
        >
            <div className="fsf-na-light-box">
                <FSFNotAvailableLightBoxHeader />
                <FSFNotAvailableLightBoxContent productType={props.productType}/>
            </div>
        </Lightbox>
    );
}

FSFNotAvailableLightBox.propTypes = {
    visible: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    productType: PropTypes.string.isRequired,
};

export { FSFNotAvailableLightBox };
